/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from "react";
import { Container } from "reactstrap";
import CTA from "../assets/images/bg/nadi-cta.jpg";
import { useTranslation } from "react-i18next";

export default function SectionPrivacyPolicy() {
  const { t, i18n } = useTranslation();
  const privacyPolicy = () => [
    {
      id: "service1",
      title: t("privacy_policy.section_1.title"),
      description: t("privacy_policy.section_1.description"),
    },
    {
      id: "service2",
      title: t("privacy_policy.section_2.title"),
      description: t("privacy_policy.section_2.description"),
    },
    {
      id: "service3",
      title: t("privacy_policy.section_3.title"),
      description: t("privacy_policy.section_3.description"),
    },
    {
      id: "service4",
      title: t("privacy_policy.section_4.title"),
      description: t("privacy_policy.section_4.description"),
    },
    {
      id: "service5",
      title: t("privacy_policy.section_5.title"),
      description: t("privacy_policy.section_5.description"),
    },
    {
      id: "service6",
      title: t("privacy_policy.section_6.title"),
      description: t("privacy_policy.section_6.description"),
    },
  ];

  const privacyPolicyData = useMemo(() => privacyPolicy(), [i18n.language]);

  return (
    <>
      <section className="section" style={{ background: `url(${CTA}) center` }}>
        <div className="bg-overlay"></div>
        <Container>
          <div className="row justify-content-center">
            <div className="col">
              <div className="section-title text-center">
                <h4 className="title text-white">
                  {t("privacy_policy.title")}
                </h4>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <section className="section bg-light" id="solution">
        <Container>
          <div className="container">
            <div className="row align-items-center">
              <div className="col-12">
                <div className="me-lg-5">
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {privacyPolicyData.map((item) => (
                        <div
                          key={item.id}
                          className="section-title text-md-start mb-4 pb-2"
                        >
                          <h4 className="title mb-3">{item.title}</h4>
                          <p className="text-muted mx-auto mb-0">
                            {item.description}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}
